import { connect } from "react-redux";
import { withRouter } from "react-router";
import React from "react";
import styles from "./ProjectItem.module.scss";
import Fade from "react-reveal/Fade";
import moment from "moment";
import { fireAnalytics } from "../../../utils/firebase";
import { ReactComponent as ZoneIcon } from "../../../assets/svg/descriptionIcon.svg";
import { ReactComponent as DateIcon } from "../../../assets/svg/locationIcon.svg";
import { ReactComponent as PliegoIcon } from "../../../assets/svg/planos.svg";
import usePremiumCheck from "../../../hooks/usePremiumCheck";


const ProjectItem = ({ item, isAdjudicated, isQuotation }) => {
  const {
    name,
    province,
    empresa,
    information,
    startDate,
    description,
    currency,
    monto,
    link,
    zone,
    fuente,
    comitente,
  } = item;

  const formatDate = (date) => {
    if (date !== null) {
      const formattedStartDate = moment(date).format("DD/MM/YYYY");
      return formattedStartDate;
    } else {
      return date;
    }
  };

  const handleOnClick = () => {
    if (link) {
      window.open(link, "_blank");
      fireAnalytics("dsh_public_bit", { category: "dashboard" });
    }
  };
  const current = function (number) {
    return new Intl.NumberFormat().format(number);
  };
  const date = isAdjudicated
    ? "Fecha de Adjudicación:"
    : "Fecha de apertura:";
  const projectType = isQuotation
    ? "Entidad pública"
    : isAdjudicated
      ? "Proyecto Adjudicado"
      : "Proyecto a licitar";
  const ubicacion = isAdjudicated ? province : zone;
  const descripcion = isAdjudicated ? empresa : comitente;
  return (
    <Fade style={{ height: "100%", with: "100%" }}>
      <div className={styles.container} key={item.id} link={link}>
        <div className={styles.itemContainer}>
          <div className={styles.itemHeader}>
            <p className={styles.name}>{name}</p>
          </div>
          <div className={styles.itemContainer_content}>
          <div className={styles.itemContainer_content_item}>
              <div className={styles.ubication}>Tipo de proyecto:</div>
              <div className={styles.zone}>
                <p>{projectType}</p>
              </div>
            </div>
            <div className={styles.itemContainer_content_item}>
              <div className={styles.ubication}>Ubicación:</div>
              <div className={styles.zone}>
                <p>{ubicacion}</p>
              </div>
            </div>
            <div className={styles.itemContainer_content_item}>
              <div className={styles.organization}>
                {isAdjudicated ? "Empresa Adjudicada:" : " Organización:"}
              </div>
              <p className={styles.organizationContainer}>
                {isQuotation ? comitente : descripcion}
              </p>
            </div>
            <div className={styles.itemContainer_content_item}>
              <div className={styles.itemContainer_content_item_date}>
                {date}
              </div>
              <div className={styles.dateContainer}>
                <p>{formatDate(startDate)}</p>
              </div>
            </div>
            <div className={styles.itemContainer_content_item}>
              <div className={styles.itemContainer_content_item_monto}>
                {isQuotation ? "Presupuesto:" : "Monto:"}
              </div>
              <div className={styles.dateContainer}>
                {currency}
                {current(monto)}
              </div>
            </div>
            {!isAdjudicated ? (
              <div className={styles.itemContainer_content_item}>
                <div className={styles.description}>Descripción: </div>
                <div className={styles.descriptionText}>{isQuotation ? description : description}</div>
              </div>
            ) : null}
          </div>
        </div>
        <div className={styles.buttonContainer}>
          <p>
            {isAdjudicated ? (
              <div style={{ color: "#858585" }}>Fuente: {fuente}</div>
            ) : null}
          </p>
          <button className={styles.button} onClick={handleOnClick}>
            <PliegoIcon width={25} height={25} />
            Acceso al pliego oficial
          </button>
        </div>
      </div>
    </Fade>
  );
};
const mapStateToProps = (state, ownProps) => {
  return {
    meSession: state.general.meSession,
    profileMenu: state.profile.menuShow,
  };
};

export default withRouter(connect(mapStateToProps, {})(ProjectItem));
